/**
 * Decrypt ElGamal ciphertext using randomness (PedersenOpening)
 * This uses the WASM module to perform the decryption
 */
export const decryptElGamalWithRandomness = async (wasmModule, ciphertextBase64, randomnessBase64) => {
  if (!wasmModule || !wasmModule.decrypt_ciphertext_with_randomness) {
    throw new Error('WASM module not initialized or missing decrypt_ciphertext_with_randomness function');
  }

  try {
    const result = wasmModule.decrypt_ciphertext_with_randomness(
      ciphertextBase64,
      randomnessBase64
    );

    if (!result) {
      throw new Error('Decryption returned null or undefined');
    }

    const parsedResult = JSON.parse(result);
    
    if (!parsedResult.decrypted_amount) {
      throw new Error('Decryption result missing decrypted_amount');
    }

    return parsedResult.decrypted_amount;
  } catch (error) {
    console.error('ElGamal decryption error:', error);
    throw new Error(`Failed to decrypt ElGamal ciphertext: ${error.message}`);
  }
};
